<template>
    <v-app id="onPten" v-if="!loading">
        <v-main>
            <v-container fluid class="pa-4">
                <v-row class="pb-0 justify-center">
                    <h2 v-if="pten.pten_code !== ''">Lead (Potential host) {{ pten.pten_code }}</h2>
                    <h2 v-else>Create new lead (Potential host)</h2>
                </v-row>
                <v-row>
                    <!-- Links -->
                    <v-col cols="6" class="px-2">
                        <!-- Lead -->
                        <v-card class="mb-4 pa-2">
                            <v-form ref="ptenCard3" v-model="ptenCard3Valid">
                                <v-card-title class="pt-0 pb-0 justify-center">Lead Details</v-card-title> 
                                <v-divider></v-divider> 
                                <div class="ml-4 pt-2">
                                    <v-row no-gutters class="pt-2">                                                        
                                        <v-col cols="4" class="pr-4 pb-4 pointer" @click="changeStatus">
                                            <span>Lead status</span><br>
                                            {{ pten.ptst_oms }}
                                        </v-col>                                                        
                                        <v-col cols="3" class="pr-4">
                                            <v-select v-model="pten.ptld_code" :readonly="disableAll" :clearable="!disableAll" :items="ptld_codeKeuzes" :rules="pten_sourceRules" item-value="ptld_code" item-text="ptld_oms" label="Source of lead"  dense></v-select>
                                        </v-col>
                                        <v-col cols="5" class="pr-4">
                                            <v-text-field v-model="pten.pten_source_detail" label="Source detail" :readonly="disableAll" dense></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters class="py-2">
                                        <v-col cols="4" class="pr-4 pb-4">
                                            <span>Lead date</span><br>
                                            {{ pten.pten_dt }}
                                        </v-col>
                                        <v-col cols="3" class="pr-4">
                                            <v-text-field v-model="pten.gebr_code" readonly label="Assigned agent" dense></v-text-field>
                                            <v-btn class="primary pa-3 mr-3" :disabled="!allowChangeAgent" small @click="assignPtenLead">Assign agent</v-btn>
                                        </v-col>                                                    
                                        <v-col cols="3" class="pr-4">
                                            <v-text-field v-model="pten.ambassador" readonly label="Ambassador" dense></v-text-field>
                                            <v-btn class="primary pa-3 mr-3" :disabled="!allowChangeAmbassador" small @click="assignPtenAmbassador">Assign ambassador</v-btn>
                                        </v-col>                                                    
                                    </v-row>
                                </div>
                                <div v-if="pten.pten_encrid !== ''">
                                    <v-divider></v-divider>
                                    <v-card-actions>
                                        <btn_audit table="pten" :encrid="pten.pten_encrid"/>
                                        <v-spacer></v-spacer>
                                        <v-btn class="primary pa-3 mr-3" :disabled="disableAll||!ptenCard3Valid" small @click="savePtenCard3">Save</v-btn>
                                    </v-card-actions>
                                </div>
                            </v-form>
                        </v-card>
                        <!-- Host -->
                        <v-card class="mb-4 pa-2">
                            <v-form ref="ptenCard1" v-model="ptenCard1Valid">
                                <v-card-title class="pt-0 pb-0 justify-center">Potential Host Details</v-card-title>  
                                <leadBV :owners="pten.lead_BV" :accos="[]" v-if="pten.lead_BV.length>0"/> 
                                <v-divider v-if="pten.lead_BV.length===0"></v-divider>                
                                <div class="ml-4 pt-4">
                                    <v-row no-gutters>
                                        <v-col cols="6" class="pr-4">
                                            <v-text-field v-model="pten.pten_bedrijfsnaam" :readonly="disableAll" label="Company name" dense></v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row no-gutters>
                                        <v-col cols="6" class="pr-4">
                                            <v-text-field v-model="pten.pten_voornaam" :readonly="disableAll" label="First name" dense></v-text-field>
                                        </v-col>
                                        <v-col cols="6" class="pr-4">
                                            <v-text-field v-model="pten.pten_naam" :readonly="disableAll" :rules="pten_naamRules" label="Last name" dense></v-text-field>
                                        </v-col>             
                                    </v-row>

                                    <v-row no-gutters>
                                        <v-col cols="2" class="pr-4">
                                            <v-select v-model="pten.taal_code" :readonly="disableAll" :clearable="!disableAll" :items="taal_codeKeuzes" item-value="taal_code" item-text="taaltaal_oms" label="Language" dense></v-select>
                                        </v-col>

                                        <v-col cols="4" class="pr-4">
                                            <v-text-field v-model="pten.pten_tel1_vcs" :readonly="disableAll" label="Tel Number" dense></v-text-field>
                                        </v-col>  

                                        <v-col cols="3" class="pr-4">
                                            <v-text-field v-model="pten.pten_tel1_type" readonly label="Type" dense></v-text-field>
                                        </v-col>

                                        <v-col cols="3" class="pr-4">
                                            <v-checkbox v-model="pten.pten_tel1_approved" readonly label="Numverify Approved" dense></v-checkbox>
                                        </v-col>
                                    </v-row>

                                    <v-row no-gutters>
                                        <v-col cols="6" class="pr-4">
                                            <v-text-field v-model="pten.pten_email" :readonly="disableAll" :rules="pten_emailRules" label="Email" dense></v-text-field>
                                        </v-col>
                                    </v-row>                                    
                                    
                                    <v-row no-gutters>
                                        <v-col cols="6" class="pr-4">
                                            <v-text-field v-model="pten.pten_adres" :readonly="disableAll" label="Address Street / Housenumber" dense></v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row no-gutters>
                                        <v-col cols="2" class="pr-4">
                                            <v-text-field v-model="pten.pten_postcode" :readonly="disableAll" label="Postcal code" dense></v-text-field>
                                        </v-col>
                                        <v-col cols="5" class="pr-4">
                                            <v-text-field v-model="pten.pten_plaats" :readonly="disableAll" label="City" dense></v-text-field>
                                        </v-col>

                                        <v-col cols="5" class="pr-4">
                                            <v-select v-model="pten.land_code" :readonly="disableAll" :clearable="!disableAll" :items="land_codeKeuzes" item-value="land_code" item-text="landtaal_oms" label="Country" dense></v-select>
                                        </v-col>
                                    </v-row>

                                    <v-row no-gutters v-if="!pten.pten_geen_nieuwsbrief">
                                        <v-col cols="4" class="px-1">
                                            <v-checkbox v-model="pten.pten_nieuwsbrief" label="Host Newsletter" dense></v-checkbox>
                                        </v-col>

                                        <v-col cols="3" class="px-1">
                                            <v-text-field v-if="pten.pten_inschrijf_dt > ''" v-model="pten.pten_inschrijf_dt" label="Opt-IN" readonly dense></v-text-field>
                                        </v-col>  

                                        <v-col cols="3" class="px-1">
                                            <v-text-field v-if="pten.pten_uitschrijf_dt > ''" v-model="pten.pten_uitschrijf_dt" label="Opt-OUT" readonly dense></v-text-field>
                                        </v-col>  
                   
                                    </v-row>

                                    <v-row no-gutters v-if="!pten.pten_geen_nieuwsbrief">
                                        <v-col cols="4" class="px-1">
                                            <v-checkbox v-model="pten.pten_klnt_nieuwsbrief" label="Guest Newsletter" dense></v-checkbox>
                                        </v-col>

                                        <v-col cols="3" class="px-1">
                                            <v-text-field v-if="pten.pten_klnt_inschrijf_dt > ''" v-model="pten.pten_klnt_inschrijf_dt" label="Opt-IN" readonly dense></v-text-field>
                                        </v-col>  

                                        <v-col cols="3" class="px-1">
                                            <v-text-field v-if="pten.pten_klnt_uitschrijf_dt > ''" v-model="pten.pten_klnt_uitschrijf_dt" label="Opt-OUT" readonly dense></v-text-field>
                                        </v-col>  
                                    </v-row>

                                    <v-row no-gutters v-else>
                                        <v-col cols="15" class="px-1 pt-4">
                                            <br>
                                            {{ pten.pten_geen_nieuwsmsg }}<br>
                                            <br>
                                       </v-col>  
                                    </v-row>

                                </div>
                                <div v-if="pten.pten_encrid !== ''">
                                    <v-divider></v-divider>
                                    <v-card-actions>
                                        <btn_audit table="pten" :encrid="pten.pten_encrid"/>
                                        <v-spacer></v-spacer>
                                        <v-btn class="primary px-3 py-3 mr-3" :disabled="disableAll||!ptenCard1Valid" small @click="savePtenCard1">Save</v-btn>
                                    </v-card-actions>
                                </div>
                            </v-form>
                        </v-card>
                        <!-- Accommodation -->
                        <v-card class="mb-4 pa-2">
                            <v-form ref="ptenCard2" v-model="ptenCard2Valid">
                                <v-card-title class="pt-0 pb-0 justify-center">Potential Accommodation Details</v-card-title>  
                                <leadBV :owners="[]" :accos="pten.lead_BV" v-if="pten.lead_BV.length>0"/> 
                                <v-divider v-if="pten.lead_BV.length===0"></v-divider>                
                                <div class="ml-4 pt-4">  
                                    <v-row no-gutters>
                                        <v-col cols="4" class="pr-4">
                                            <v-text-field v-model="pten.pten_huis_current_company" :readonly="disableAll" label="Current company" hint="Fill in 'None' if there is no current company" dense></v-text-field>
                                        </v-col>
                                        <v-col cols="4" class="pr-4">
                                            <v-text-field v-model="pten.pten_huis_current_id" :readonly="disableAll" label="Current ID" hint="Fill in 'None' if there is no current ID" dense></v-text-field>
                                        </v-col>
                                    </v-row>  
                                    <v-row no-gutters class="pb-4">
                                        <v-col cols="8" class="pr-4">
                                            <links :links="pten.pten_huis_current_link" :disabled="disableAll" labelNone="Link to current accommodation" @updateData="updateData"/>
                                        </v-col>
                                    </v-row>
                                    <v-divider></v-divider>

                                    <v-row no-gutters class="pt-4">
                                        <v-col cols="6" class="pr-4">
                                            <v-text-field v-model="pten.pten_huis_adres" :readonly="disableAll" label="Address Street / Housenumber" dense></v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row no-gutters>
                                        <v-col cols="2" class="pr-4">
                                            <v-text-field v-model="pten.pten_huis_postcode" :readonly="disableAll" label="Postcal code" dense></v-text-field>
                                        </v-col>
                                        <v-col cols="5" class="pr-4">
                                            <v-text-field v-model="pten.pten_huis_plaats" :readonly="disableAll" label="City" dense></v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row no-gutters>
                                        <v-col cols="4" class="pr-4">
                                            <v-select v-model="pten.pten_huis_prov_code" :readonly="disableAll" :clearable="!disableAll" :items="prov_land_codeKeuzes" item-value="prov_code" item-text="provtaal_oms" label="Province" dense></v-select>
                                        </v-col>
                                        <v-col cols="4" class="pr-4">
                                            <v-select v-model="huis_land_code" :readonly="disableAll" :clearable="!disableAll" :items="land_codeKeuzes" item-value="land_code" item-text="landtaal_oms" label="Country" dense></v-select>
                                        </v-col>
                                    </v-row> 

                                    <v-row no-gutters>
                                        <v-col cols="3" class="pr-4">
                                            <v-text-field v-model="huis_gps" :disabled="disableAll" @click="openMap()" label="Latitude / Longitude" readonly dense></v-text-field>
                                        </v-col>
                                        <v-col cols="3" class="pr-4">
                                            <v-btn class="primary px-3 py-3 mr-3" :disabled="disableAll" small @click="openMap()">Show map</v-btn>
                                        </v-col>
                                        <v-col cols="3" class="pr-4">
                                            <v-btn class="primary px-3 py-3 mr-3" :disabled="disableAll" small @click="crtMarker()" v-if="pten.pten_huis_lat===0&&pten.pten_huis_lng===0">Address to coordiantes</v-btn>
                                        </v-col>                                    
                                    </v-row>

                                    <v-divider></v-divider>

                                    <v-row no-gutters class="pt-4">
                                        <v-col cols="4" class="pr-4">
                                            <v-select v-model="pten.pten_huis_hstp_nr" :readonly="disableAll" :clearable="!disableAll" :items="hstp_codeKeuzes" item-value="hstp_code" item-text="hstptaal_oms" label="Accommodation type" dense></v-select>
                                        </v-col>

                                        <v-col cols="2" class="pr-4">
                                            <v-text-field v-model="pten.pten_huis_aantpers_max" :readonly="disableAll" label="Max Pers" type="number" prepend-icon="mdi-account" dense></v-text-field>
                                    </v-col>
                                    <v-col cols="2" class="pr-4">
                                            <v-text-field v-model="pten.pten_huis_aant_bedrooms" :readonly="disableAll" label="Bedrooms" type="number" dense></v-text-field>
                                    </v-col>
                                    <v-col cols="2" class="pr-4">
                                            <v-text-field v-model="pten.pten_huis_aant_bathrooms" :readonly="disableAll" label="Bathrooms" type="number" dense></v-text-field>
                                    </v-col>
                                    </v-row>  
                                </div>                              
                                <div v-if="pten.pten_encrid !== ''">
                                    <v-divider></v-divider>
                                    <v-card-actions>
                                        <btn_audit table="pten" :encrid="pten.pten_encrid"/>                                                        
                                        <v-spacer></v-spacer>
                                        <v-btn class="primary px-3 py-3 mr-3" :disabled="disableAll||!ptenCard2Valid" small @click="savePtenCard2">Save</v-btn>
                                    </v-card-actions>
                                </div>
                            </v-form>
                        </v-card>
                    </v-col>

                    <!-- Rechts  -->
                    <v-col cols="6" class="px-2">
                        <!-- Actions -->
                        <v-card class="mb-4 pa-2" v-if="pten.pten_encrid === ''">
                            <v-card-title class="pt-0 pb-0 justify-center">New Lead Actions</v-card-title>
                            <v-divider></v-divider>
                            <v-checkbox v-model="addAction" disabled label="Add action to new lead" dense></v-checkbox>
                            <v-form ref="action" v-model="actionValid" v-if="addAction">
                                <v-row no-gutters class="ma-4 mb-0">
                                    <v-col cols="6" class="pr-4">
                                        <v-select v-model="ptac.patp_code" :disabled="ptac.ptac_nr!==0" :clearable="true" :items="ptac.patp_codeKeuzes" :rules="typeRules" item-value="patp_code" item-text="patp_oms" label="Type of action" v-on:change="changeType" dense></v-select>
                                    </v-col>  
                                    <v-col cols="6" v-if="!isFolderAction">
                                        <date_picker label="Complete action before" :date="ptac.ptac_actie_dt" field="ptac_actie_dt" @updateData="updateData1" dense/> 
                                    </v-col>
                                </v-row>
                                <v-row no-gutters class="mx-4 mb-4" v-if="!isFolderAction">
                                    <v-col cols="12" >
                                        <v-textarea v-model="ptac.ptac_oms" rows="4" label="Action description" :rules="descriptionRules" dense></v-textarea>
                                    </v-col>
                                </v-row>
                                <div v-if="isFolderAction">
                                    <v-divider></v-divider>
                                    <v-card-title class="justify-center">Follow up action</v-card-title>
                                    <v-divider></v-divider>
                                    <v-row no-gutters class="ma-4 mb-0">
                                        <v-col cols="6" class="pr-4">
                                            <v-select v-model="followUp.patp_code" :clearable="true" :items="codeKeuzes" :rules="typeRules" item-value="patp_code" item-text="patp_oms" label="Type of follow up action" dense></v-select>
                                        </v-col>  
                                        <v-col cols="6">
                                            <date_picker label="Follow up complete before" :date="followUp.ptac_actie_dt" field="ptac_actie_dt" @updateData="updateData2" dense/> 
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters class="mx-4 mb-4">
                                        <v-col cols="12">
                                            <v-textarea v-model="followUp.ptac_oms" rows="4" label="Follow up description" :rules="descriptionRules" dense></v-textarea>
                                        </v-col>
                                    </v-row>
                                </div>
                            </v-form>
                            <v-divider></v-divider>
                            <v-card-actions>
                                <v-btn class="primary px-3 py-3 mr-3" small @click="clearLead">Clear lead</v-btn>
                                <!-- <v-btn class="primary px-3 py-3 mr-3" small :disabled="!ptenCard1Valid||!ptenCard2Valid||!ptenCard3Valid" @click="createLead(false)">Create lead</v-btn> -->
                                <v-btn class="primary px-3 py-3 mr-3" small @click="createLead(false)">Create lead</v-btn>
                                <v-spacer></v-spacer>
                                <!-- <v-btn class="error px-3 py-3 mr-3" small :disabled="!ptenCard1Valid||!ptenCard2Valid||!ptenCard3Valid" @click="createLead(true)" v-if="showDuplicates">Create, ignore duplicates</v-btn> -->
                                <v-btn class="error px-3 py-3 mr-3" small @click="createLead(true)" v-if="showDuplicates">Create, ignore duplicates</v-btn>
                            </v-card-actions>
                        </v-card>

                        <!-- Deduplicate -->
                        <v-card class="mb-4 pa-2" v-if="deduplicate">
                            <v-card-title class="pt-0 pb-0 justify-center">Deduplicate action</v-card-title>
                            <v-divider></v-divider>
                            <v-card-actions>
                                <v-btn class="primary px-3 py-3 mr-3" small @click="refreshDuplicates()">Refresh duplicates</v-btn>
                                <v-spacer></v-spacer>
                                <v-btn class="primary px-3 py-3 mr-3" small @click="setPtenStatus('012-NewAssign')" v-if="pten.ptst_code!=='010-TelephoneList'">Not a duplicate</v-btn>
                                <v-btn class="primary px-3 py-3 mr-3" small @click="setPtenStatus('102-DuplicateLead')">Set as duplicate with a lead</v-btn>
                                <v-btn class="primary px-3 py-3 mr-3" small @click="setPtenStatus('101-DuplicateHost')">Set as duplicate with a host</v-btn>
                            </v-card-actions>
                        </v-card>
                        <!-- Deduplicate details -->
                        <tablePtenDeduplicate ref="tablePtenDeduplicate" :pten_encrid="pten_encrid" :pten="pten" @actionClick="actionClick" v-if="deduplicate||showDuplicates"/>

                        <!-- Actions for this lead -->
                        <tablePtenAction ref="tablePtenAction" :agent="agent" :pten_encrid="pten_encrid" @actionClick="actionClick" :addAction="true" typeList="lead" v-if="pten.pten_encrid !== ''&&!deduplicate"/>
                    </v-col>
                </v-row>
            </v-container>
        </v-main>
        <!-- Navbar --> 
        <navbarPten :menuIndex="pten_encrid === '' ? '3' : '0'" :menuType="pten_encrid === '' ? 'pten' : 'pten-lead'" :data="pten_encrid" :attms="pten.attm_aant" :notts="pten.nott_aant" :mails="pten.mail_aant" @actionClick="actionClick" />
        <m_attm ref="m_attm"/>
        <nott ref="nott"/>
        <emails ref="emails"/>
        <showMap ref="map" :title="map_title" :latitude="pten.pten_huis_lat" :longitude="pten.pten_huis_lng" @updateGPS="updateGPS" />
        <onAction ref="onAction" @actionClick="actionClick" />
        <sendPtenEmail ref="sendPtenEmail" :pten_encrid="pten_encrid" @actionClick="actionClick"/>
        <changeStatus ref="changeStatus" @actionClick="actionClick" />
        <setPtenToEign ref="setPtenToEign" :pten_encrid="pten_encrid" />
        <assignLead ref="assignLead" @actionClick="actionClick"/>
        <reopenLead ref="reopenLead" @actionClick="actionClick" />
        <closeLead ref="closeLead" @actionClick="actionClick" />
        <select_ambassador ref="ambassador" @actionClick="updateAmbassador"/>
    </v-app>
    
</template>

<script>
    import {bus} from "../../main";
    
    import links from "@/components/ui/links.vue";
    import btn_audit from "@/components/ui/buttons/btn_audit.vue";
    import date_picker from "@/components/ui/date_picker.vue";
    import select_ambassador from "@/components/ui/selectors/select_ambassador.vue";
    import m_attm from "@/components/m_attm.vue";
    import nott from "@/components/nott.vue";
    import emails from "@/components/emails.vue";
    
    import navbarPten from "@/components/pten/navbarPten.vue";
    import tablePtenAction from "@/components/pten/tablePtenAction.vue";
    import tablePtenDeduplicate from "@/components/pten/tablePtenDeduplicate.vue";
    import showMap from "@/components/pten/showMap.vue";
    import onAction from "@/components/pten/onAction.vue";
    import sendPtenEmail from "@/components/pten/sendPtenEmail.vue";
    import changeStatus from "@/components/pten/changeStatus.vue";
    import setPtenToEign from "@/components/pten/setPtenToEign.vue";
    import assignLead from "@/components/pten/assignLead.vue";
    import reopenLead from "@/components/pten/reopenLead.vue";
    import closeLead from "@/components/pten/closeLead.vue";
    import leadBV from "@/components/pten/leadBV.vue";

    export default {
        components: {
            links,
            date_picker,
            select_ambassador,
            m_attm,
            nott,
            emails,
            btn_audit,
            showMap,
            navbarPten,
            tablePtenAction,
            tablePtenDeduplicate,
            onAction,
            sendPtenEmail,
            changeStatus,
            setPtenToEign,
            assignLead,
            reopenLead,
            closeLead,
            leadBV,
        },
        props: {
            pten_encrid: {
                type: String,
                required: false,
                default: "",
            },
        },
        computed: {
            huis_gps() {
                return Number.parseFloat(this.pten.pten_huis_lat).toFixed(5) + " / " + Number.parseFloat(this.pten.pten_huis_lng).toFixed(5);
            },
            map_title() {
                return "Accommodation location for potential lead " + this.pten.pten_code;
            },
            deduplicate() {
                return this.pten_encrid !== "" && (this.pten.ptst_code === "011-NewDeduplicate" || this.pten.ptst_code === "010-TelephoneList");
            },
            disableAll() {
                return this.pten_encrid !== "" && this.pten.ptst_code >= "100";
            },
        },
        data() {
            return {
                loading: true,

                agent: "",
                showDuplicates: false,
                allowChangeAgent: false,
                allowChangeAmbassador: false,
                actionValid: false,

                ptenCard1Valid: false,
                ptenCard2Valid: false,
                ptenCard3Valid: false,

                huis_land_code: "xx",  // non existant value of "xx" forces a refresh of prov_land_codeKeuzes

                //aanh_codeKeuzes: [],
                taal_codeKeuzes: [],
                land_codeKeuzes: [],
                prov_codeKeuzes: [],
                prov_land_codeKeuzes: [],
                hstp_codeKeuzes: [],
                ptld_codeKeuzes: [],
                ptst_codeKeuzes: [],
                gebr_codeKeuzes: [],

                pten: {
                    pten_huis_current_link: [],
                },
                pten_sourceRules: [(v) => (v && v.length >= 1) || "A source is required"],
                pten_naamRules: [(v) => (v && v.length >= 2) || "A last name is required"],
                // pten_FirstNaamRules: [(v) => (v && v.length >= 2) || "A first name is required"],
                pten_emailRules: [(v) => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,6})+$/.test(v) || "E-mail must be valid", (v) => (v && v.length >= 3) || "Email is required"],

                // Meteen actie toevoegen
                addAction: true,
                isFolderAction: false,
                codeKeuzes: [],
                ptac: {
                    ptac_nr: 0,
                },
                followUp: {},
                followUp00: {},
                followUp05: {},
                typeRules: [(v) => (v && v.length >= 1) || "A type of action is required"],
                descriptionRules: [v => !!v || "A description / value is required"],
                dateRules: [v => (v && v.length == 10) || "DD-MM-YYYY"],
            };
        },
        created() {
            bus.$on("closeDialog", (data) => {
                // console.log(data);
                if(data==="reload" || data==="attm_m_attm") {
                    this.getPten();
                }
            });  
            bus.$on("addNote", (data) => {
                // console.log(data);
                this.pten.nott_aant += data;
            });
        },
        mounted() {
            this.getPten();
            this.getAction();
        },
        watch: {
            huis_land_code(value) {
                this.provLand(value);
            },
            pten_encrid() {
                this.getPten();
            },
        },
        methods: {
            getPten() {
                this.loading = true;
                this.$axios.post("ares/json/ares/pten/getPten.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getPten",
                    },
                    getPten: {
                        pten_encrid: this.pten_encrid,
                    },
                }).then((res) => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.pten = res.data.getPten;
                        
                        //this.aanh_codeKeuzes = res.data.getPten.aanh_codeKeuzes;
                        this.taal_codeKeuzes = res.data.getPten.taal_codeKeuzes;
                        this.land_codeKeuzes = res.data.getPten.land_codeKeuzes;
                        this.prov_codeKeuzes = res.data.getPten.prov_codeKeuzes;
                        this.hstp_codeKeuzes = res.data.getPten.hstp_codeKeuzes;
                        this.ptld_codeKeuzes = res.data.getPten.ptld_codeKeuzes;
                        this.ptst_codeKeuzes = res.data.getPten.ptst_codeKeuzes;
                        this.gebr_codeKeuzes = res.data.getPten.gebr_codeKeuzes;

                        this.huis_land_code = this.pten.pten_huis_land_code;

                        if (res.data.getPten.pten_code === "") {
                            document.title = "ARES New Lead ";
                        } else {
                            document.title = "ARES Lead " + res.data.getPten.pten_code;
                        }
                        this.allowChangeAgent = res.data.getPten.allowChangeAgent;
                        this.allowChangeAmbassador = res.data.getPten.allowChangeAmbassador;
                        this.loading = false;
                    }
                });
            },
            getAction() {
                this.$axios.post("ares/json/ares/pten/getActionNewPten.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getActionNewPten",
                    },
                    getActionNewPten: {
                    },
                }).then((res) => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.ptac = res.data.getActionNewPten;
                        //console.log(this.ptac.ptac_actie_dt);
                        this.ptac.ptac_actie_dt = this.getDate(this.ptac.ptac_actie_dt);
                        //console.log(this.ptac.ptac_actie_dt);
                        this.codeKeuzes = res.data.getActionNewPten.patp_codeKeuzes;
                        this.followUp = res.data.getActionNewPten.follow_up;
                        //console.log( this.followUp.ptac_actie_dt);
                        this.followUp.ptac_actie_dt = this.getDate(this.followUp.ptac_actie_dt);
                        //console.log( this.followUp.ptac_actie_dt);
                        this.followUp05 = res.data.getActionNewPten.follow_up_05;
                        this.followUp05.ptac_actie_dt = this.getDate(this.followUp05.ptac_actie_dt);
                        this.followUp00 = res.data.getActionNewPten.follow_up_00;
                        this.followUp00.ptac_actie_dt = this.getDate(this.followUp00.ptac_actie_dt);
                        this.changeType(this.ptac.patp_code);
                    }
                });
            },
            provLand(land) {
                /*
                    Provincie bij gekozen land
                */
                this.pten.pten_huis_land_code = land;
                // Land is waarschijnlijk gewijzigd, provincie leeg maken.
                let prov = this.pten.pten_huis_prov_code
                this.pten.pten_huis_prov_code = "";
                // Land is gewijzigd, provincie bij land bepalen.
                if (land === "") {
                    // alle landen + provincies.
                    this.prov_land_codeKeuzes = this.prov_codeKeuzes;
                } else {
                    this.prov_land_codeKeuzes = [];
                    for (let i = 0; i < this.prov_codeKeuzes.length; i++) {
                        if (this.prov_codeKeuzes[i].land_code === land) {
                            this.prov_land_codeKeuzes.push(this.prov_codeKeuzes[i]);
                            if (this.prov_codeKeuzes[i].prov_code === prov) {
                                this.pten.pten_huis_prov_code = prov;
                            }
                        }
                    }
                }
            },
            addFormData(data, form) {
                if (form === "ptenCard1") {
                    data["pten_encrid"] = this.pten_encrid; 
                    data["pten_bedrijfsnaam"] = this.pten.pten_bedrijfsnaam; 
                    data["pten_voornaam"] = this.pten.pten_voornaam;
                    data["pten_naam"] = this.pten.pten_naam;
                    data["taal_code"] = this.pten.taal_code;
                    data["pten_tel1_vcs"] = this.pten.pten_tel1_vcs;
                    data["pten_email"] = this.pten.pten_email;
                    data["pten_adres"] = this.pten.pten_adres;
                    data["pten_postcode"] = this.pten.pten_postcode;
                    data["pten_plaats"] = this.pten.pten_plaats;
                    data["land_code"] = this.pten.land_code;
                    data["nieuwsbrief"] = this.pten.pten_nieuwsbrief && !this.pten.pten_geen_nieuwsbrief;
                    data["klnt_nieuwsbrief"] = this.pten.pten_klnt_nieuwsbrief && !this.pten.pten_geen_nieuwsbrief;
                }
                if (form === "ptenCard2") {
                    data["pten_encrid"] = this.pten_encrid;
                    data["pten_huis_land_code"] = this.pten.pten_huis_land_code;
                    data["pten_huis_lat"] = parseFloat(this.pten.pten_huis_lat);
                    data["pten_huis_lng"] = parseFloat(this.pten.pten_huis_lng),
                    data["pten_huis_prov_code"] = this.pten.pten_huis_prov_code;
                    data["pten_huis_plaats"] = this.pten.pten_huis_plaats;
                    data["pten_huis_hstp_nr"] = this.pten.pten_huis_hstp_nr;
                    data["pten_huis_adres"] = this.pten.pten_huis_adres;
                    data["pten_huis_postcode"] = this.pten.pten_huis_postcode;
                    data["pten_huis_aantpers_max"] = this.pten.pten_huis_aantpers_max;
                    data["pten_huis_aant_bedrooms"] = this.pten.pten_huis_aant_bedrooms;
                    data["pten_huis_aant_bathrooms"] = this.pten.pten_huis_aant_bathrooms;
                    data["pten_huis_current_company"] = this.pten.pten_huis_current_company;
                    data["pten_huis_current_id"] = this.pten.pten_huis_current_id;
                    data["pten_huis_current_link"] = this.pten.pten_huis_current_link;
                }
                if (form === "ptenCard3") {
                    data["pten_encrid"] = this.pten_encrid;
                    data["ptld_code"] = this.pten.ptld_code;
                    data["pten_source_detail"] = this.pten.pten_source_detail;
                    data["gebr_code"] = this.pten.gebr_code; 
                }
                if (form === "action") {
                    data["addAction"] = this.addAction;
                    data["ptac_actie_dt_ok"] = this.setDate(this.ptac.ptac_actie_dt);
                    data["patp_code"] = this.ptac.patp_code;
                    data["ptac_oms"] = this.ptac.ptac_oms; 
                    data["follow_up"] = this.followUp;
                }
                return data;
            },   
            savePtenCard1() {
                if (this.$refs.ptenCard1.validate()) {
                    this.$axios.post("ares/json/ares/pten/savePtenCard1.p", {
                        header: {
                            token: this.$session.get("ARES"),
                            clientSessionId: this.$session.id(),
                            request: "savePtenCard1",
                        },
                        savePtenCard1: this.addFormData({}, "ptenCard1"),
                    }).then((res) => {
                        if (res.data.error) {
                            console.log(res.data.error);
                        } else {
                            this.$store.dispatch("setSnackbar", {
                                showing: true,
                                text: res.data.savePtenCard1.text,
                                color: res.data.savePtenCard1.color,
                            });
                        }
                        this.getPten();
                    });
                }
            },
            savePtenCard2() {
                if (this.$refs.ptenCard2.validate()) {
                    this.$axios.post("ares/json/ares/pten/savePtenCard2.p", {
                        header: {
                            token: this.$session.get("ARES"),
                            clientSessionId: this.$session.id(),
                            request: "savePtenCard2",
                        },
                        savePtenCard2: this.addFormData({}, "ptenCard2"),
                    }).then((res) => {
                        if (res.data.error) {
                            console.log(res.data.error);
                        } else {
                            this.$store.dispatch("setSnackbar", {
                                showing: true,
                                text: res.data.savePtenCard2.text,
                                color: res.data.savePtenCard2.color,
                            });
                        }
                    });
                }
            },
            savePtenCard3() {
                if (this.$refs.ptenCard3.validate()) {
                    this.$axios.post("ares/json/ares/pten/savePtenCard3.p", {
                        header: {
                            token: this.$session.get("ARES"),
                            clientSessionId: this.$session.id(),
                            request: "savePtenCard3",
                        },
                        savePtenCard3: this.addFormData({}, "ptenCard3"),
                    }).then((res) => {
                        if (res.data.error) {
                            console.log(res.data.error);
                            this.$store.dispatch("setSnackbar", {
                                showing: true,
                                text: res.data.error.message,
                                color: res.data.error.color,
                            });
                        } else {
                            this.$store.dispatch("setSnackbar", {
                                showing: true,
                                text: res.data.savePtenCard3.text,
                                color: res.data.savePtenCard3.color,
                            });
                            this.actionClick("refresh");
                        }
                    });
                }
            },
            openMap() {
                this.$refs.map.open();
            },
            crtMarker() {
                this.$axios.post("ares/json/ares/pten/setPtenLatLng.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "setPtenLatLng",
                    },
                    setPtenLatLng: {
                        pten_encrid: this.pten_encrid,
                    },
                }).then((res) => {
                    if (res.data.error) {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.setPtenLatLng.text,
                            color: res.data.setPtenLatLng.color,
                        });
                        this.actionClick("refresh");
                    }
                })             
            },
            createLead(allowDuplicates) {
                if (!this.$refs.ptenCard3.validate()) {
                    return;
                }
                if (!this.$refs.ptenCard1.validate()) {
                    return;
                }
                if (!this.$refs.ptenCard2.validate()) {
                    return;
                }
                if (this.addAction) {
                    if (!this.$refs.action.validate()) {
                        return;
                    }
                    if (this.ptac.patp_code === "05-SendFolder") {
                        if ((typeof this.followUp.ptac_actie_dt === "undefined") || (this.followUp.ptac_actie_dt === null) || (this.followUp.ptac_actie_dt === "")) {
                            this.$store.dispatch("setSnackbar", {
                                showing: true,
                                text: "A follow up action date must be given",
                                color: "error",
                            });  
                            return                  
                        }
                    } else {
                        if ((typeof this.ptac.ptac_actie_dt === "undefined") || (this.ptac.ptac_actie_dt === null) || (this.ptac.ptac_actie_dt === "")) {
                            this.$store.dispatch("setSnackbar", {
                                showing: true,
                                text: "Action date must be given",
                                color: "error",
                            });  
                            return                  
                        }
                    }
                }
                this.followUp.ptac_actie_dt_ok = this.setDate(this.followUp.ptac_actie_dt);
                
                this.showDuplicates = false;

                let allData = this.addFormData({}, "ptenCard1");
                allData = this.addFormData(allData, "ptenCard2");
                allData = this.addFormData(allData, "ptenCard3");
                allData = this.addFormData(allData, "action");
                allData["allowDuplicates"] = allowDuplicates;

                this.$axios.post("ares/json/ares/pten/savePten.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "savePten",
                    },
                    savePten: allData,
                }).then((res) => {
                    if (res.data.error) {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.savePten.text,
                            color: res.data.savePten.color,
                        });
                        this.showDuplicates = res.data.savePten.showDuplicates;
                        if (this.showDuplicates) {
                            this.refreshDuplicates();
                        }
                    }
                });
            },           
            refreshDuplicates() {
                this.$refs.tablePtenDeduplicate.getPtenDuplicates();
            },
            setPtenStatus(newStatus) {
                this.$refs.tablePtenDeduplicate.setPtenStatus(this.pten_encrid, newStatus);
            },
            clearLead() {
                this.showDuplicates = false;
                this.getPten();
            },
            updateGPS(lat, lng) {
                this.pten.pten_huis_lat = lat;
                this.pten.pten_huis_lng = lng;
                this.savePtenCard2();
            },
            actionClick(action, agent) {
                //console.log(action, agent);
                switch (action) {
                    case "closeEmail": 
                        location.reload();
                        break;
                    case "refresh":
                        this.getPten();
                        this.$refs.navBar.getMenuByType();
                        break;
                    case "refreshActions":
                        this.$refs.tablePtenAction.getActions();
                        break;
                    case "m_attm":
                        this.$refs.m_attm.open("pten", this.pten.pten_code, "", "pten", this.pten_encrid, 0);
                        break;
                    case "nott":
                        this.$refs.nott.open("pten", this.pten_encrid, "all");
                        break;
                    case "mails":
                        this.$refs.emails.openDialog("pten-code", this.pten.pten_code, "Mails for lead " +  this.pten.pten_code);
                        // this.$refs.emails.openDialog("huov-code", "240300541", "Mails for lead " +  this.pten.pten_code);
                        break;                                
                    case "addAction":
                        this.$refs.onAction.openDialog(this.pten_encrid, this.pten.pten_code, 0);
                        break;
                    case "changeStatus":
                        this.changeStatus();
                        break;
                    case "setAgent": 
                        this.pten.gebr_code = agent;
                        break;
                    case "infoEmail":
                        this.$refs.sendPtenEmail.openDialog("Send information email", "infoEmail");
                        break;
                    case "setLeadToHost":
                        this.$refs.setPtenToEign.openDialog();
                        break;
                    case "reopenLead":
                        this.reopenLead();
                        break;
                    case "closeLead":
                        this.closeLead();
                        break;
                    default:
                        break;
                }
            },
            updateData(data) {
                console.log(data);
            },
            changeStatus() {
                let leadStats = [];
                for (let i = 0; i < this.ptst_codeKeuzes.length; i++) {
                    if (this.ptst_codeKeuzes[i].ptst_code < "080") {
                        leadStats.push(this.ptst_codeKeuzes[i])
                    }
                }
                this.$refs.changeStatus.openDialog(this.pten, leadStats);
            },     
            assignPtenLead() {
                this.$refs.assignLead.open(this.pten, this.gebr_codeKeuzes);
            },
            assignPtenAmbassador() {
                this.$refs.ambassador.openSelect(this.pten.eign_code_ambas, this.pten.ambassador);
            },
            updateAmbassador(value, naam) {
                if (value !== this.pten.eign_code_ambas) {
                    this.$axios.post("ares/json/ares/pten/savePtenAmbassador.p", {
                        header: {
                            token: this.$session.get("ARES"),
                            clientSessionId: this.$session.id(),
                            request: "savePtenAmbassador",
                        },
                        savePtenAmbassador: {
                            pten_encrid: this.pten_encrid,
                            eign_code_ambas: value,
                        },
                    })
                    .then((res) => {
                        if (res.data.error) {
                            //console.log(res.data.error);
                            this.$store.dispatch("setSnackbar", {
                                showing: true,
                                text: res.data.error.message,
                                color: "warning",
                            });
                        } else {
                            this.$store.dispatch("setSnackbar", {
                                showing: true,
                                text: res.data.savePtenAmbassador.text,
                                color: res.data.savePtenAmbassador.color,
                            });
                            this.pten.eign_code_ambas = value;
                            this.pten.ambassador = naam;
                        }
                    });                    
                }

            },
            reopenLead() {
                let leadStats = [];
                for (let i = 0; i < this.ptst_codeKeuzes.length; i++) {
                    if (this.ptst_codeKeuzes[i].ptst_code < "100") {
                        leadStats.push(this.ptst_codeKeuzes[i])
                    }
                }
                this.$refs.reopenLead.openDialog(this.pten, leadStats);
            },
            closeLead() {
                let closedStats = [];
                for (let i = 0; i < this.ptst_codeKeuzes.length; i++) {
                    if (this.ptst_codeKeuzes[i].ptst_code >= "100") {
                        closedStats.push(this.ptst_codeKeuzes[i])
                    }
                }
                this.$refs.closeLead.openDialog(this.pten, closedStats);
            },
            getDate(value) {
                if  (value === ""||value === null) {
                    return "";
                }
                if (value.substring(4, 5) === "-"||value.substring(4, 5) === "/") {
                    return value.substring(5, 7) + "-" + value.substring(8, 10) + "-" + value.substring(0, 4); 
                }
                return value.substring(3, 5) + "-" + value.substring(0, 2) + "-" + value.substring(6, 10);
            },
            setDate(date) {
                if (date.substring(2, 3) === "-") {
                    return date.substring(3, 5) + "-" + date.substring(0, 2) + "-" + date.substring(6, 10); 
                }
                return date.substring(8, 10) + "-" + date.substring(5, 7) + "-" + date.substring(0, 4); 
            },
            updateData1(data) {
                this.ptac[data.field] = data.value;
            },
            updateData2(data) {
                this.followUp[data.field] = data.value;
            },
            changeType(value) {
                this.isFolderAction = (value === "05-SendFolder"); 
                if (this.isFolderAction) {
                    this.followUp = this.followUp05; 
                } else {
                    this.followUp = this.followUp00;                     
                }            
            },
            // parseDate(date) {
            //     if (!date) return null;

            //     const [month, day, year] = date.split("/");
            //     return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
            // },
        },
    };
</script>

<style scoped>
    .text-field-style >>> .v-text-field__slot input {
        color: grey;
        font-weight: 300; /* 800 being bold so this is less than half bold */
    }    
    .text-grey {
        color: grey !important;
        font-weight: 400 !important; /* 800 being bold so this is half bold */
    }
    .td_markup {
        vertical-align: top;
        border-top: 5px solid transparent;
        font-size: 15px !important;
        /* trick to add padding to a TD element (which is not possible with CSS normally) */
    }
    .td_markup_img {
        vertical-align: top;
    }
    .flex {
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    .column {
        position: inherit;
        width: 20%;
    }
    .col-value {
        float:right; 
        font-weight: bold; 
        padding-right: 40px;
    }
    .gps {
        cursor: grab !important;
    }
    .pointer {
        cursor: pointer;
    }
</style>